module.exports = __webpack_public_path__ + "img/ic_phone.ba6c1f70.svg";